import { useCallback, useState } from 'react'

import logger from 'utils/logger'

import { getTopicRefinementSuggestions } from 'services/completions.service'

const useTopicRefinement = () => {
	const [aiResponse, setAiResponse] = useState('')
	const [loading, setLoading] = useState(false)

	const clearResponse = useCallback(() => {
		setAiResponse('')
	}, [])

	const requestRefinement = useCallback(
		async (businessProblem: string, companyName: string) => {
			try {
				setLoading(true)
				const response = await getTopicRefinementSuggestions({
					businessProblem,
					companyName,
				})
				if (response.status === 200 && response.data?.response) {
					setAiResponse(response.data.response)
				}
			} catch (error) {
				logger.error(error)
			} finally {
				setLoading(false)
			}
		},
		[]
	)

	return {
		aiResponse,
		clearResponse,
		loading,
		requestRefinement,
	}
}

export default useTopicRefinement
